import { configureApiEntity } from '../adapter';
import { schema } from 'normalizr';

const registrySchema = new schema.Entity('registry');

export const registries = configureApiEntity('REGISTRIES', 'registries', registrySchema);
